import { useEffect } from 'react'
import { StringParam, useQueryParam, withDefault } from 'use-query-params'

import type { TabPillsProps } from '@components/common/TabPills/types'
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'

export const useAnalyticsTabs = () => {
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const [tabParam, setTabParam] = useQueryParam('tab', withDefault(StringParam, 'overview'))
  const { currentShop } = useCurrentShop({ staleTime: Infinity })
  const membershipsEnabled =
    !!currentShop?.settings.memberships?.enabled && dashboardFeatureFlags.memberships.enabled
  const isAnalyticsTabsEnabled = dashboardFeatureFlags.analyticsTabs.enabled && membershipsEnabled

  const tabs: TabPillsProps['options'] = isAnalyticsTabsEnabled
    ? [
        { label: 'Overview', value: 'overview' },
        { label: 'Shop', value: 'shop' },
        { label: 'Memberships', value: 'memberships' },
      ]
    : []

  const isValidTab = isAnalyticsTabsEnabled ? tabs.some((tab) => tab.value === tabParam) : true

  let activeTab: string
  if (isAnalyticsTabsEnabled) {
    activeTab = isValidTab ? tabParam : 'overview'
  } else {
    activeTab = 'overview'
  }

  useEffect(() => {
    if (!isAnalyticsTabsEnabled) {
      if (tabParam !== undefined) {
        setTabParam(undefined)
      }

      return
    }

    if (
      isAnalyticsTabsEnabled &&
      ((activeTab === 'memberships' && !membershipsEnabled) || !isValidTab)
    ) {
      setTabParam('overview')
    }
  }, [activeTab, membershipsEnabled, isValidTab, isAnalyticsTabsEnabled, tabParam, setTabParam])

  const handleTabChange = (value: string) => {
    if (isAnalyticsTabsEnabled) {
      setTabParam(value)
    }
  }

  return {
    tabs,
    activeTab,
    onTabChange: handleTabChange,
  }
}
